/* Types and formatters shared by the admin (zones.scai.fm) and the Studio console (studio.scai.fm). */

/** "evening" -> "Evening", "late-night" -> "Late night" */
export const daypartName = (dp: string) => (dp === 'default' ? 'Default' : (dp.charAt(0).toUpperCase() + dp.slice(1)).replace(/-/g, ' '));

export const fmtDur = (ms: number) => {
  const s = Math.round(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

export type DJ = { id: string; slug: string; display_name: string; bio: string | null; voice: string | null; language: string;
  persona_model: string; character_blob: string; stations: string[]; talks: boolean };
/** What a station plays: songs only, songs and the DJ's links, a presenter over the music, a live input. */
export type Mode = 'auto' | 'dj' | 'voice' | 'live';
export type Programme = { slug: string; name: string; description: string | null; brief: string | null; talk: 'none' | 'low' | 'normal' | 'more';
  mode: Mode | null;
  source: 'mix' | 'new' | 'most_played'; genre_mix: { genre: string; weight: number }[]; constraints: Record<string, any> | null; hours_per_week: number };
/** A slot of a station's weekly grid; same time rules as a zone's opening hours. */
export type GridSlot = { weekday: number; start: string; end: string; programme: string };
export type Station = { id: string; slug: string; name: string; description: string | null; dj: DJ | null; timezone: string; sort_order: number;
  /** customer: a Studio station, owned by customer_id, off the public list unless listed */
  kind: 'public' | 'customer'; customer_id: string | null; listed: boolean;
  status: 'off' | 'on_air' | 'maintenance'; format: { adverts: boolean; top_of_hour: boolean; no_repeat_hours: number;
    /** idents (customer stations): before each hour's first song; every N songs (0: never) */
    idents_hour: boolean; sweeper_every: number }; mount: string | null;
  programmes: Programme[]; grid: GridSlot[]; on_air: { programme: string; name: string; until: string | null }; listeners: number;
  /** the default; override: the console's, while it runs; mode_now: what plays (null: taken down) and why */
  mode: Mode; override: { mode: Mode; until: string | null } | null;
  /** liquidsoap: its own Liquidsoap on fe1; timeline: played by the edge like a zone (crossfade_ms: 0 = butt joins) */
  playout: 'liquidsoap' | 'timeline'; crossfade_ms: number;
  mode_now: { mode: Mode | null; source: 'takedown' | 'override' | 'live' | 'programme' | 'station'; wanted: Mode | null; until: string | null };
  /** customer stations: % of songs from the owner's uploads; licence_declared: uploads matching a known recording may play */
  own_share: number; licence_declared: boolean; shouts: boolean; dj_allowed: boolean };
